import { h, Host } from "@stencil/core";
import { debounce } from "../../utils/debounce";
export class Steps {
    constructor() {
        this.current = 0;
        this.items = 0;
        this.bottomGutter = 0;
    }
    element;
    /**
     * creates step-items
     * @param {Number} n number of items in indicator
     */
    createSteps(n) {
        const stepElements = [];
        for (let i = 1; i < n + 1; i++) {
            stepElements.push(h("ux-steps-item", { number: i, current: i === this.current, done: i < this.current }));
        }
        return stepElements;
    }
    componentWillLoad() {
        this.getBottomGutter();
    }
    onResize() {
        this.updateBottomGutter();
    }
    updateBottomGutter = debounce(() => {
        this.getBottomGutter();
    }, 200);
    getBottomGutter = () => {
        // @ts-expect-error Check for typing
        const stepItems = Array.from(this.element.shadowRoot.querySelectorAll("ux-steps-item"));
        // @ts-expect-error Check for typing
        let stepText = stepItems.map((stepItem) => stepItem.shadowRoot.querySelector("p"));
        if (stepText.length === 0) {
            // @ts-expect-error Check for typing
            const slot = this.element.shadowRoot.querySelector("slot");
            if (!slot)
                return;
            const assignedElements = slot.assignedElements();
            // @ts-expect-error Check for typing
            stepText = assignedElements.map((assignedElement) => assignedElement.shadowRoot.querySelector("p"));
        }
        if (stepText.length === 0)
            return; // no step text found
        const heights = [];
        stepText.forEach((stepText) => {
            // @ts-expect-error Check for typing
            const height = stepText.getBoundingClientRect().height;
            heights.push(height + (height > 0 ? 10 : 0));
        });
        this.bottomGutter = Math.max(...heights);
        this.element.style.setProperty("--ux-steps-item-padding-bottom", `${this.bottomGutter}px`);
    };
    render() {
        const baseClass = "ux-steps";
        return (h(Host, { key: 'd6dcc981f3bfdaadde4b2c881fc869a930b1549e', generated: this.items > 0, "aria-label": "progress" }, h("div", { key: 'ade70051c9c63b7872604d591dbb4a3eb5e0c241', "aria-hidden": "true", class: `${baseClass}__outer-line ${baseClass}__outer-line--left ` }), h("div", { key: 'd2fbe411dac6f7eb708c3e53bff389d5bc5bf1fe', class: `${baseClass}__indicators` }, this.createSteps(this.items), h("slot", { key: 'd8d5fa6b605f5127c24345941318ad8e296147f7', onSlotchange: () => this.getBottomGutter() })), h("div", { key: 'd08135904dd5aca1a9e35ae8c9b5f3ef047f4cd7', "aria-hidden": "true", class: `${baseClass}__outer-line ${baseClass}__outer-line--right ` })));
    }
    static get is() { return "ux-steps"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["steps.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["steps.css"]
        };
    }
    static get properties() {
        return {
            "current": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "this value is representing the current active step"
                },
                "attribute": "current",
                "reflect": false,
                "defaultValue": "0"
            },
            "items": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "this value is representing number of steps"
                },
                "attribute": "items",
                "reflect": false,
                "defaultValue": "0"
            }
        };
    }
    static get states() {
        return {
            "bottomGutter": {}
        };
    }
    static get elementRef() { return "element"; }
    static get listeners() {
        return [{
                "name": "resize",
                "method": "onResize",
                "target": "window",
                "capture": false,
                "passive": true
            }];
    }
}
//# sourceMappingURL=steps.js.map
